/**
 * Runtime configuration for MotoTrips
 * 
 * Smart API base detection for custom domain deployments.
 * When the app runs on a custom domain (e.g., stg1.mototrips.net, mototrips.net),
 * API calls use the same-origin to avoid CORS issues, since frontend and backend
 * share the same Emergent deployment.
 * 
 * On Emergent preview/dev domains, it falls back to REACT_APP_BACKEND_URL.
 */
const ENV_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const resolveBackendUrl = () => {
  if (typeof window === 'undefined') return ENV_BACKEND_URL;
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isEmergentDomain = hostname.includes('emergentagent.com') || hostname.includes('emergent.host');
  if (!isLocalhost && !isEmergentDomain) {
    return window.location.origin;
  }
  return ENV_BACKEND_URL;
};

export const BACKEND_URL = resolveBackendUrl();
